import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BillingOrderControlService } from '../../../services/billing/billing-order-control.service';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { Router } from '@angular/router';
import { async } from 'rxjs/internal/scheduler/async';
import { AuthService } from '../../../services/auth.service';
import { SectorType } from 'src/app/enums/sector-type.enum';
import { BillingOrderControlView } from '../../../model/billing/billing-order-control-view';

@Component({
  selector: 'app-billing-do-orden-control-dialog',
  templateUrl: './billing-do-orden-control-dialog.component.html',
  styleUrls: ['./billing-do-orden-control-dialog.component.css']
})
export class BillingDoOrdenControlDialogComponent implements OnInit {

  form: FormGroup;
  loading: boolean;
  protocol: string;

  constructor(public dialogRef: MatDialogRef<BillingDoOrdenControlDialogComponent>,
    private billingOrderControlService: BillingOrderControlService,
    private router: Router,
    private authService: AuthService,
    private notificationToastService: NotificationToastService,
    private formBuilder: FormBuilder) {

      this.form = this.formBuilder.group({
        Protocol: ['' , [Validators.required]]
      });

      this.form.controls.Protocol.valueChanges.subscribe(async (value: string) => {
        if ( value ) {
          const replace = /\-/gi;
          this.protocol = value.replace(replace, '');
          if ( this.protocol.length === 14 ) {
            await this.save();
          }
        }
      });
    }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
    this.router.navigate(['home']);
  }

  async save() {
    if (this.protocol && this.protocol.length === 14) {
      try {
        this.loading = true;
        if ( this.authService.isBillingSector() ) {
          await this.findProtocol();
        } else {
          this.notificationToastService.error('Debe estar logueado en un sector de facturación', 'Control órden');
        }
      } catch ( err ) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Control órden');
      } finally {
        this.loading = false;
      }
    }
  }

  private async findProtocol() {
    const info = await this.billingOrderControlService.getBillingOrderControlView(this.form.getRawValue().Protocol);

    if (info) {
      if (this.isOrderInSector(info)) {
        this.dialogRef.close(info);
      } else {
        this.notificationToastService.error('La orden no se encuentra en el sector', 'Control órden');
      }
    }
  }

  private isOrderInSector(info: BillingOrderControlView) {
    return info.SectorId === this.authService.getSectorId() && info.InSector;
  }
}
